import firebase from "firebase/app";
import "firebase/messaging";

const firebaseConfig = {
    apiKey: "AIzaSyCIAqN_OEjjNYKgYcRxWoDsbG1jv9xOtpE",
    authDomain: "adelaidefooty-dd4eb.firebaseapp.com",
    projectId: "adelaidefooty-dd4eb",
    storageBucket: "adelaidefooty-dd4eb.appspot.com",
    messagingSenderId: "155304670865",
    appId: "1:155304670865:web:9b3004b31ee0fcf498b130"
};

const vapidKey = "BBcURZfs6UUcUIdyMnaW7M45n_kfGfj3i94tAEfbCyqLgvOPFP0K8_02J8rCm8ZvAwgui6rTe2ftOPNEMqVCd1I";

// Initialize Firebase
let messaging = null;

try {
    if (!firebase.apps.length) {
        firebase.initializeApp(firebaseConfig);
    }
    
    // Check if messaging is supported
    if (firebase.messaging.isSupported()) {
        messaging = firebase.messaging();
    } else {
        console.warn("Firebase messaging is not supported in this browser");
    }
} catch (error) {
    console.error("Firebase initialization error:", error);
}

export const requestFCMToken = async () => {
    if (!messaging) {
        throw new Error("Firebase messaging is not available");
    }

    try {
        const permission = await Notification.requestPermission();
        
        if (permission === "granted") {
            const token = await messaging.getToken({ vapidKey });
            console.log("FCM Token received:", token);
            return token;
        } else {
            throw new Error("Permission not granted for notifications");
        }
    } catch (err) {
        console.error("Error requesting FCM token:", err);
        throw err;
    }
};

// Set foreground message listener
export const onMessageListener = () => {
    if (!messaging) {
        return Promise.reject(new Error("Firebase messaging is not available"));
    }

    return new Promise((resolve) => {
        messaging.onMessage((payload) => {
            console.log('[App] Received foreground message:', payload);
            resolve(payload);
        });
    });
};

// Subscribe to FCM token refresh
export const onTokenRefresh = (callback) => {
    if (!messaging) {
        console.warn("Firebase messaging is not available for token refresh");
        return;
    }

    messaging.onTokenRefresh(() => {
        messaging.getToken({ vapidKey }).then((refreshedToken) => {
            console.log('Token refreshed:', refreshedToken);
            if (callback && typeof callback === 'function') {
                callback(refreshedToken);
            }
        }).catch((err) => {
            console.error('Unable to retrieve refreshed token:', err);
        });
    });
};

// Check if browser supports notifications
export const isNotificationSupported = () => {
    return 'Notification' in window && 'serviceWorker' in navigator && firebase.messaging.isSupported();
};

// Get current FCM token
export const getCurrentToken = async () => {
    if (!messaging) {
        throw new Error("Firebase messaging is not available");
    }

    try {
        const token = await messaging.getToken({ vapidKey });
        return token;
    } catch (err) {
        console.error("Error getting current token:", err);
        throw err;
    }
};

// Alias for compatibility
export const getExistingFCMToken = getCurrentToken;

// Get current notification permission status
export const getNotificationPermission = () => {
    if ('Notification' in window) {
        return Notification.permission;
    }
    return 'unsupported';
};

// Check if browser is Safari
export const isSafari = () => {
    const userAgent = navigator.userAgent.toLowerCase();
    return userAgent.indexOf('safari') !== -1 && userAgent.indexOf('chrome') === -1;
};

// Save FCM token to backend (temporary implementation)
export const saveTokenToBackend = async (token) => {
    try {
        console.log('Token to save:', token);
        // Temporary implementation - just log the token
        // You can uncomment the actual implementation when backend is ready
        /*
        const response = await fetch('/api/push/subscribe', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                token: token,
                userAgent: navigator.userAgent,
                timestamp: new Date().toISOString()
            })
        });

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        const result = await response.json();
        console.log('Token saved to backend:', result);
        return result;
        */
        return { success: true, message: 'Token logged (backend disabled)' };
    } catch (error) {
        console.error('Error saving token to backend:', error);
        throw error;
    }
};

// Export messaging instance for other places
export { messaging };
